<template>
    <div class="news" style="display: table-cell;vertical-align: middle;text-align: center">
        <!-- ============= 顶部背景图 ============= -->
        <div>
            <img src="../../assets/images/news/banner.png" style="width: 100%;display: block">
        </div>

        <!-- ============= 信息更新列表标题 ============= -->
        <div class="news-title">
            <span class="title-span"> News List </span>
            <el-select class="title-select" v-model="type_id" @change="getNews();getlefttype()">
                <el-option
                  v-for="(value, key) in resourceList"
                  :key="key"
                  :label="value"
                  :value="key"
                ></el-option>
            </el-select>
            <el-input v-model="news_search" placeholder=" Key Word " style="width: 240px;margin-left: 10px"></el-input>
            <el-button type="primary" style="width: 120px;" @click="getNews()">Search</el-button>
        </div>

        <!-- ============= 信息更新列表内容 ============= -->
        <div class="news-table"   style="display: inline-block;text-align: left">
            <el-row :gutter="24">
                 <!-- 更新列表左侧资料 -->
                <el-col :span="8">
                    <div class="title-Data" >
                        <span class="recommend-article" style="font-size: 22px">{{(left_top_name.type_e_name!='' && left_top_name.type_e_name!='null')?left_top_name.type_e_name:left_top_name.type_name}}</span>
                        <!--span style="margin-left: 60px">
                            <a style="color: rgba(74,144,226,1);cursor: pointer" @click="reload">查看更多更新>></a>
                        </span-->
                        <div class="title-Data" v-for="(item,index) in left_top">
                            <div class="table-content"><a ><span class="wtq_hover" style="cursor: pointer;" :onclick="'window.location=\'article?new_id='+item.new_id+'\''" v-html="(item.new_en_tit!='' && item.new_en_tit!=null)?item.new_en_tit:item.new_tit"></span></a></div>
                        </div>
                    </div>
                    <div style="width: 280px;">
                        <el-divider></el-divider>
                    </div>

                    <div class="title-Data" >
                        <span class="recommend-article" style="font-size: 22px">Others</span>
                        <!--span style="margin-left: 20px">
                            <a style="color: rgba(74,144,226,1);cursor: pointer" @click="reload">查看更多更新>></a>
                        </span-->
                        <div class="title-Data" v-for="(item,index) in left_down">
                            <div class="table-content"><a ><span class="wtq_hover" style="cursor: pointer;" :onclick="'window.location=\'article?new_id='+item.new_id+'\''" v-html="(item.new_en_tit!='' && item.new_en_tit!=null)?item.new_en_tit:item.new_tit"></span></a></div>
                        </div>
                        <!--<div class="article-item"><a>ProWriter烧写器应用软件V3.2.4.8!</a></div>-->
                        <!--<div class="table-content"><a>SH79F6442 Demo Code已经更新至V1.0! </a></div>-->
                        <!--<div class="table-content"><a>SH79F6441 用户指南已经更新至V1.0!</a></div>-->
                        <!--<div class="table-content"><a>SH79F6441 Demo Code已经更新至V1.0!</a></div>-->



                      <div class="table-content" v-for="(item,index)  in otherArticle" :key="index">
                        <a @click="reload()">{{item.title}}</a>
                      </div>
                    </div>
                </el-col>
                <!-- 更新列表右侧表格 -->
                <el-col span="16">
                    <div style="margin-left: 120px;margin-top: 40px">
                        <el-table :data="jobTabledata" style="width: 720px">
                            <el-table-column  prop="type_name" >
                                <template slot="header">
                                    <span style="font-size: 16px;color: #fff"> Category </span>
                                </template>
                            </el-table-column>

                            <el-table-column  prop="new_tit" width="360">
                                <template slot="header">
                                    <span style="font-size: 16px;color: #fff;"> Title </span>
                                </template>
                                 <template slot-scope="scope">
                                    <span class="wtq_hover" style="cursor: pointer;" :onclick="'window.location=\'article?new_id='+scope.row.new_id+'\''" v-html="scope.row.new_tit"></span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" prop="new_have">
                                <template slot="header">
                                    <span style="font-size: 16px;color: #fff"> Update time </span>
                                </template>
                            </el-table-column>
                        </el-table>

                        <div class="news-pages"  style="margin-top: 40px;">
                            <el-pagination
                             @current-change="change_page"
                             @size-change="change_size"
                              :pagesize="show"
                              background
                              :current-page="page"
                              :page-count="page"
                              layout="prev, pager, next"
                              :total="total"
                              hide-on-single-page>
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                page: 1, // 当前页码
                total: 0, // 总条数
                allPage: 0, // 总条数
                show: 10, // 当前每页显示条数
                skillArticle: [],
                otherArticle: [],
                jobTabledata: [],
                
                resourceList: [],
                
                news_search:'',
                type_id:'70',
                
                left_top_name:[],
                left_top:[],
                left_down:[],
            }
        },
        mounted:function(){
            let type_id=this.get_get_val('type_id');
            if(type_id){
                this.type_id=type_id;
            }
            this.getOtherArticle();
            this.getSkillArticle();
            this.getJobTableData();
            this.getNews();
            this.getNewstype();
            this.getlefttype();
        },
        methods: {
            change_page(val){
                this.page=val;
                this.getNews();
            },
            change_size(val){
                this.show=val;
                this.getNews();
            },
            getNews () { // 获取信息列表
                let _this = this;
                //获取GET的值
                
                
                
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/look_news?english=english&type=2&new_type_id='+this.type_id+'&page='+this.page+'&show='+this.show+'&news_search='+this.news_search+'&type_id='+this.type_id,
                }).then((response) =>{
                    this.jobTabledata = response.data.news
                    this.skillArticle = response.data.news_shows
                    this.page  = response.data.page_msg.page
                    this.allPage  = response.data.page_msg.allPage
                    this.total  = response.data.page_msg.show * response.data.page_msg.all_page
                    this.show  = response.data.page_msg.show
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            getNewstype(){
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/news_type?english=english',
                }).then((response) =>{
                    this.resourceList = response.data;
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            getlefttype(){
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/look_news?english=english&type=1&new_type_id='+this.type_id,
                }).then((response) =>{
                    this.left_top_name = response.data.tit;
                    this.left_top = response.data.news;
                    this.left_down = response.data.new_all;
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            handleNodeClick(data) {
                console.log(data);
            },
            reload:function () {
                window.location.reload();
            },
            getOtherArticle: function () {
                // api.http_mock('/api/getOtherArticle').then(res => {
                //     console.log("tableDataTest---->", res);
                //     this.otherArticle = res;
                // })
            },
            getSkillArticle: function () {
                // api.http_mock('/api/getSkillArticle').then(res => {
                //     console.log("tableDataTest---->", res);
                //     this.skillArticle = res;
                // })
            },
            getJobTableData: function () {
                // api.http_mock('/api/getJobTableData').then(res => {
                //     console.log("tableDataTest---->", res);
                //     this.jobTabledata = res;
                // })
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
            go_news:function (){
                alert(123)
            }
        }
  };
</script>

<style >
    .news th { background-color:  rgba(108,152,255,1) !important; }
    .news .news-title { line-height: 200px;height: 120px }
    .news .title-span { font-size: 36px;color: rgba(51,51,51,1); }
    .news .news-table { padding: 20px;/*height: 720px*/ }
    .news .article-item { margin-top: 40px;font-size: 14px }
    .news  .title-select { margin-left: 15%;line-height: 0px;width: 240px }
    .news .title-Data { margin-top: 40px; }
    .news .table-content { margin-top: 25px;font-size: 14px;cursor: pointer }
    
    .wtq_hover:hover{color: #6190cd;}
</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue